import EventDispatcher from './events/EventDispatcher';
import * as FEATURES from './layout/features';
import { ALIGN, VALIGN } from './globals';
import { Utils } from './Utils';
import Sprite from './display/Sprite';

class Stage extends EventDispatcher {

    constructor(layout, config, scale=1, type=0) {
        super();

        this.config = Utils.clone(config);
        this.layout = layout;

        this.screen = layout.addScreen();

        var options = {
            view: this.screen.canvas,
            resolution: scale,
            transparent: config.transparentStage == undefined ? true : config.transparentStage
        };

        if(type == PIXI.RENDERER_TYPE.WEBGL) {
            this.renderer = new PIXI.WebGLRenderer(config.size.width, config.size.height, options);
        }
        else if(FEATURES.IE || type == PIXI.RENDERER_TYPE.CANVAS) {
            this.renderer = new PIXI.CanvasRenderer(config.size.width, config.size.height, options);
        }
        else {
            this.renderer = PIXI.autoDetectRenderer(config.size.width, config.size.height, options);
        }

        this.renderer.plugins.interaction.moveWhenInside = true;

        this.layout.on("fitlayout", (e) => {

            if(this.layout.autoFill) {
                this.resize(e.screenWidth, e.screenHeight);
            }

        });

        this.view = new Sprite();

        this.viewAlign = {
            x: ALIGN.CENTER,
            y: VALIGN.MIDDLE
        };

        this.autoRender = true;

        this.alignView();
    }

    alignView(align=this.viewAlign.x, valign=this.viewAlign.y) {

        this.viewAlign.x = align;
        this.viewAlign.y = valign;

        let x = 0, y = 0;
        let sw = this.screen.canvas.width / this.layout.bitmapScale;
        let sh = this.screen.canvas.height / this.layout.bitmapScale;

        if(align == ALIGN.CENTER) x = sw/2;
        if(align == ALIGN.RIGHT) x = sw;

        if(valign == VALIGN.MIDDLE) y = sh/2;
        if(valign == VALIGN.BOTTOM) y = sh;

        this.view.position.set(x, y);
    }

    resize(width, height) {
        this.renderer.resize(width, height);
        this.alignView();
    }

    render() {
        this.renderer.render(this.view);
    }

    tick(delta) {
        if(!this.autoRender) return;

        this.render();
    }
}

export default Stage;
